/**
 * Loox recensioni: nasconde la griglia #grid con display none (da JS).
 */
(function() {
  var LOG_PREFIX = '[Loox Slider]';
  var GRID_SELECTOR = '#looxReviews #grid, #looxReviews [data-sample="false"].grid-col-2';

  function hideLooxGrid() {
    var grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;
    if (grid.dataset.looxHidden === '1') return;
    grid.dataset.looxHidden = '1';
    grid.style.setProperty('display', 'none', 'important');
    console.log(LOG_PREFIX, 'grid nascosto (display:none da JS)');
  }

  function initLooxSlider() {
    var grid = document.querySelector('#looxReviews #grid, #looxReviews [data-sample="false"].grid-col-2');
    if (!grid) {
      console.log(LOG_PREFIX, 'initLooxSlider: #grid non trovato');
      return;
    }
    if (grid.dataset.sliderInited === '1') {
      console.log(LOG_PREFIX, 'initLooxSlider: già inizializzato, skip');
      return;
    }
    grid.dataset.sliderInited = '1';
    console.log(LOG_PREFIX, 'initLooxSlider: grid trovato', grid);

    var container = grid.closest('#looxReviews') || grid.parentElement;
    if (!container) {
      console.log(LOG_PREFIX, 'initLooxSlider: container (#looxReviews) non trovato');
      return;
    }

    var wrap = container.querySelector('.loox-reviews-slider-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'loox-reviews-slider-wrap';
      grid.parentNode.insertBefore(wrap, grid);
      wrap.appendChild(grid);
      console.log(LOG_PREFIX, 'wrapper .loox-reviews-slider-wrap creato');
    }

    var items = grid.querySelectorAll('.grid-item-wrap');
    var count = items.length;
    if (count === 0) {
      console.log(LOG_PREFIX, 'initLooxSlider: nessun .grid-item-wrap trovato');
      return;
    }
    console.log(LOG_PREFIX, 'recensioni trovate:', count);

    function getSlidesPerView() {
      return window.innerWidth <= 768 ? 1 : 2;
    }

    function getSlideCount() {
      var perView = getSlidesPerView();
      return Math.ceil(count / perView);
    }

    function createDots() {
      var existing = wrap.querySelector('.loox-reviews-slider-dots');
      if (existing) existing.remove();
      var slideCount = getSlideCount();
      console.log(LOG_PREFIX, 'createDots: slideCount =', slideCount, '(perView =', getSlidesPerView() + ')');
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'loox-reviews-slider-dots';
      dotsWrap.setAttribute('aria-label', 'Paginazione recensioni');
      for (var i = 0; i < slideCount; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Vai alla slide ' + (i + 1));
        btn.classList.toggle('is-active', i === 0);
        btn.dataset.index = i;
        btn.addEventListener('click', function() {
          goToSlide(parseInt(this.dataset.index, 10));
        });
        dotsWrap.appendChild(btn);
      }
      wrap.appendChild(dotsWrap);
      return dotsWrap;
    }

    function goToSlide(index) {
      var slideWidth = grid.offsetWidth;
      var scrollLeft = index * slideWidth;
      grid.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      updateDots(index);
    }

    function updateDots(activeIndex) {
      var dotsWrap = wrap.querySelector('.loox-reviews-slider-dots');
      if (!dotsWrap) return;
      var buttons = dotsWrap.querySelectorAll('button');
      buttons.forEach(function(btn, i) {
        btn.classList.toggle('is-active', i === activeIndex);
      });
    }

    function getCurrentSlideIndex() {
      var slideWidth = grid.offsetWidth;
      if (slideWidth <= 0) return 0;
      var scrollLeft = grid.scrollLeft;
      return Math.round(scrollLeft / slideWidth);
    }

    var dotsWrap = createDots();
    grid.addEventListener('scroll', function() {
      updateDots(getCurrentSlideIndex());
    });

    var autoscrollInterval;
    function startAutoscroll() {
      stopAutoscroll();
      var slideCount = getSlideCount();
      if (slideCount <= 1) {
        console.log(LOG_PREFIX, 'autoscroll: disattivato (slideCount <= 1)');
        return;
      }
      console.log(LOG_PREFIX, 'autoscroll: avviato, intervallo 5s');
      autoscrollInterval = setInterval(function() {
        var current = getCurrentSlideIndex();
        var next = (current + 1) % slideCount;
        goToSlide(next);
      }, 5000);
    }
    function stopAutoscroll() {
      if (autoscrollInterval) {
        clearInterval(autoscrollInterval);
        autoscrollInterval = null;
      }
    }
    startAutoscroll();
    grid.addEventListener('mouseenter', stopAutoscroll);
    grid.addEventListener('mouseleave', startAutoscroll);
    grid.addEventListener('touchstart', stopAutoscroll, { passive: true });
    grid.addEventListener('touchend', function() { setTimeout(startAutoscroll, 3000); }, { passive: true });

    window.addEventListener('resize', function() {
      var newCount = getSlideCount();
      var oldDots = dotsWrap.querySelectorAll('button').length;
      if (newCount !== oldDots) {
        dotsWrap = createDots();
      }
    });
  }

  function runWhenGridReady() {
    var gridExists = document.querySelector(GRID_SELECTOR);
    if (gridExists) {
      hideLooxGrid();
      return;
    }
    console.log(LOG_PREFIX, 'runWhenGridReady: #grid non presente, avvio MutationObserver');
    var observer = new MutationObserver(function() {
      if (document.querySelector(GRID_SELECTOR)) {
        observer.disconnect();
        setTimeout(hideLooxGrid, 50);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() {
      observer.disconnect();
      hideLooxGrid();
    }, 3000);
  }

  console.log(LOG_PREFIX, 'script caricato, readyState =', document.readyState);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenGridReady);
  } else {
    runWhenGridReady();
  }
})();
